<template>
    <div class="multi-filter" :style="{'height': `${menuHeight}px`}">
        <div :class="['type-options', {'hide-menu': showMenu !== 'main'}]">
            <button type="button" :class="['btn', 'btn-default', {'option-selected': anyOptionsActive}]"
                @click.prevent="showMenu = 'options'" v-html="mainTitle"></button>
        </div>

        <div :class="['search-form-options', {'show-menu': showMenu === 'options'}]">
            <label class="selector-back" @click.prevent="showMenu = 'main'"><i class="fa fa-arrow-left"></i> {{ t.menu }}</label>
            <div class="checkbox" v-if="!singleSelect">
                <label class="any" :class="{'option-selected': allOptionsActive}">
                    <input type="checkbox" @click.prevent="selectAll()">
                    {{ anyText }}
                </label>
            </div>
            <div v-for="(option, index) in filterOptions" :key="index" class="checkbox">
                <label :class="{'option-selected': option.active }">
                    <input :type="singleSelect ? 'radio' : 'checkbox'" @click="toggleOption(option.id)">
                    {{ option.name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'FilterSelector',
    computed: {
        ...mapState({
            t: state => state.t.profile
        }),
        allOptionsActive() {
            let allActive = true;
            this.filterOptions.forEach((option) => {
                if (!option.active) {
                    allActive = false;
                }
            });
            return allActive;
        },
        anyOptionsActive() {
            let active = false;
            this.filterOptions.forEach((option) => {
                if (option.active) {
                    active = true;
                }
            });
            return active;
        },
        mainTitle() {
            let title = this.singleSelect ? this.filterOptions[0].name : this.anyText;
            const activeList = [];
            const maxLength = this.filterOptions.length;
            this.filterOptions.forEach((option) => {
                if (option.active) {
                    activeList.push(option.name);
                }
            });
            if (activeList.length === 1) {
                [title] = activeList;
            } else if (activeList.length > 1 && activeList.length < maxLength) {
                title = this.t.count_selected.replace('%counter', activeList.length);
            }
            return title;
        },
        menuHeight() {
            const cellHeight = 42;
            if (this.showMenu !== 'main' && this.singleSelect) {
                return (cellHeight * (this.filterOptions.length + 1)) + 5;
            } else if (this.showMenu !== 'main') {
                return (cellHeight * (this.filterOptions.length + 2)) + 5;
            }
            return cellHeight;
        }
    },
    data() {
        return {
            anyText: this.anyTextOverride ? this.anyTextOverride : this.$store.state.t.profile.any,
            filterOptions: !this.smokeOverride ? this.$store.state.config.data.formOptions[this.filter] : this.$store.state.config.data.smokers,
            selectedOptions: [],
            setByRouterFlag: false,
            storeOptionsFlag: false,
            showMenu: 'main'
        };
    },
    methods: {
        checkIfActive() {
            return this.filterOptions.filter(option => option.active).length;
        },
        selectAll() {
            let alreadyActive = true;
            // check to see if ALL are already active
            this.filterOptions.forEach((option) => {
                if (!option.active) {
                    alreadyActive = false;
                    this.selectedOptions.push(option.id);
                }
                option.active = true;
            });
            // alreadyActive will only remain true if all options are currently selected
            if (alreadyActive) {
                this.filterOptions.forEach((option) => {
                    this.selectedOptions = [];
                    option.active = false;
                });
            }
        },
        storeFilter(data) {
            this.$store.commit(`${this.store}/SET_FILTER`, data);
        },
        setSelectedByRouter() {
            this.filterOptions.forEach((option) => {
                option.active = false;
                if (this.selectedOptions && Array.isArray(this.selectedOptions)) {
                    this.selectedOptions.forEach((selectedOption) => {
                        if (option.id === selectedOption) {
                            option.active = true;
                        }
                    });
                } else if (this.selectedOptions) {
                    if (option.id === this.selectedOptions) {
                        option.active = true;
                    }
                }
            });
        },
        toggleOption(changedValue) {
            this.selectedOptions = [];
            this.filterOptions.forEach((option) => {
                if (this.singleSelect && option.id !== changedValue) {
                    option.active = false;
                }
                if (option.id === changedValue) {
                    option.active = !option.active;
                }
                if (option.active) {
                    this.selectedOptions.push(option.id);
                }
            });
        }
    },
    props: {
        anyTextOverride: {
            type: String,
            default: ''
        },
        filter: {
            // internal for route and store
            type: String,
            required: true
        },
        singleSelect: {
            type: Boolean,
            default: false
        },
        smokeOverride: {
            type: Boolean,
            default: false
        },
        setByRouter: {
            default: null
        },
        store: {
            type: String,
            required: true
        }
    },
    watch: {
        anyOptionsActive() {
            if (!this.anyOptionsActive && this.singleSelect) {
                this.selectedOptions = '';
            }
        },
        selectedOptions() {
            if (!this.setByRouterFlag && !this.storeOptionsFlag) {
                this.storeOptionsFlag = true;
                this.storeFilter({ key: this.filter, value: this.selectedOptions });
            }
            this.setByRouterFlag = false;
            this.storeOptionsFlag = false;
        },
        setByRouter(newVals) {
            if (this.selectedOptions !== newVals) {
                this.setByRouterFlag = true;
                this.selectedOptions = newVals;
                this.setSelectedByRouter();
            }
        }
    }
};

</script>
